import { Box } from "@mui/material";
import { format, parse, isValid } from "date-fns";
import { UserActionsPopover } from "./user-actions-popover";

export const UserColumns = [
  {
    accessorKey: "userId",
    header: () => <div style={{ whiteSpace: "nowrap" }}>User ID</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.userId ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "organisationName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Business Name</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.otherDetails?.organisationName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "organisationPhone",
    header: () => <div>Phone</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.otherDetails?.organisationPhone ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "organisationType",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Business Type</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.otherDetails?.organisationType ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "active",
    header: () => <div>Status</div>,
    cell: ({ row }) => {
      const isActive = row.original.active;
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 1,
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: isActive ? "#f0fdf4" : "#fef2f2",
            color: isActive ? "#15803d" : "#dc2626",
            fontSize: "0.8rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              backgroundColor: isActive ? "#16a34a" : "#dc2626",
            }}
          />
          {isActive ? "Active" : "Inactive"}
        </Box>
      );
    },
  },
  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date Created</div>,
    cell: ({ row }) => {
      const date = row.original.createdAt;
      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;
      const parsed = parse(date, "dd-MM-yyyy HH:mm:ss", new Date());
      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {isValid(parsed) ? format(parsed, "MMM d, yyyy") : "N/A"}
        </div>
      );
    },
  },
  {
    id: "actions",
    header: () => <div>Actions</div>,
    cell: ({ row }) => <UserActionsPopover user={row.original} />,
  },
];
